import { render, staticRenderFns } from "./CeldaCanal.vue?vue&type=template&id=6adeda49"
import script from "./CeldaCanal.vue?vue&type=script&setup=true&lang=js"
export * from "./CeldaCanal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports